import { render } from "./DrinkMenu.vue?vue&type=template&id=28779594"
import script from "./DrinkMenu.vue?vue&type=script&lang=js"
export * from "./DrinkMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__